import { FaSearch, FaLightbulb, FaTools, FaChartBar, FaRocket } from "react-icons/fa";

export default function SectionSeoProcess() {
  const steps = [
    {
      title: "Audit",
      text: " We begin with a comprehensive audit of your website, evaluating technical structure, on-page elements, competitor positioning, and keyword opportunities to uncover gaps and growth potential.",
      icon: <FaSearch className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Strategy",
      text: "Based on insights, we craft a tailored SEO strategy aligned with your business goals, target audience, and market landscape ensuring every action has a clear purpose.",
      icon: <FaLightbulb className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Implementation",
      text: "Our team executes the strategy by fixing technical issues, optimizing site content, improving user experience, and enhancing overall search visibility across key pages.",
      icon: <FaTools className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Reporting",
      text: " We track performance through detailed reporting covering keyword rankings, organic traffic, and conversions so you always understand what’s working and where we’re improving.",
      icon: <FaChartBar className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Growth",
      text: " SEO is never static. We continuously analyze data, refine strategies, and adapt to algorithm changes to drive sustainable growth and long-term success.",
      icon: <FaRocket className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    }
  ];

  return (
    <div className="SectionSeoProcess py-[60px] md:py-[100px] bg-white">
      <div className="text-center mb-16 max-w-4xl mx-auto">
        <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
          Our SEO Process
        </h2>
        <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
          How <span className="text-[#DA2128]">Mean3</span> Delivers SEO Success
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300"
          >
            <div className="mb-4">{step.icon}</div>
            <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515]">
              {step.title}
            </h3>
            <p className="mt-2 text-gray-600 text-sm md:text-base">{step.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
